<template>
  <div class="news">
    <div class="news-title">华院新闻</div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" class="news-list" @load="onLoad" offset="0">
      <van-cell v-for="item in newslist" :key="item.id">
        <template #title>
          <div class="cell-content" @click="getDetail(item)">
            <div class="year" v-if="item.newYear">{{ item.newYear }}</div>
            <div class="title-row">
              <span class="title-text">{{ item.title }}</span>
              <img :src="arrowIcon" class="title-arrow" alt="" />
            </div>
            <div class="time">{{ item.create_time }}</div>
          </div>
        </template>
      </van-cell>
      <img :src="toTop" alt="" class="toTop" @click="goTop">
    </van-list>
  </div>
</template>
<script>
import toTop from '@/../static/img/ecological/toTop.svg'
import arrowIcon from '@/../static/img/other/arrow.svg'
import { formatCreateTime, getYearFromDate } from '@/utils/dateFormat'
import { signalPrerenderReady } from '@/utils/prerender'
export default {
  data() {
    return {
      toTop,
      arrowIcon,
      loading: false,
      finished: false,
      page: {
        currentPage: 1,
        pageSize: 10
      },
      newslist: [],
      total: 0,
      newYear: null,
      checkData: {}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        type: "news",
        page: this.page.currentPage,
        pagesize: this.page.pageSize
      }
      const _this = this;
      this.axios.post(this.$rootUrl + "/unidt/query_article_page", params).then(function (res) {
        const { data, code, total_count } = res.data;
        if (code === 0) {
          data.forEach(item => {
            formatCreateTime(item)
            const year = getYearFromDate(item.create_time)
            if (year != _this.newYear) {
              item.newYear = year
              _this.newYear = year
            }
          })
          _this.newslist = _this.newslist.concat(...data);
          _this.total = total_count;
        }
        _this.$nextTick(function() {
          signalPrerenderReady()
        })
      }).catch(function() {
        signalPrerenderReady()
      })
    },
    getDetail(item) {
      if (!item || item.content === false) return
      this.$router.push({
        path: '/news/' + item.id
      })
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page.currentPage++;
        this.getData();
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.newslist.length >= this.total) {
          this.finished = true;
        }
      }, 1000);
    },
    goTop() {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style lang="less" scoped>
.news {
  width: 100%;
  min-height: calc(100vh - 668px);
  padding: 96px 0px 0px;
  background: #ffffff;

  .news-title {
    height: 78px;
    padding: 48px 64px;
    font-size: 44px;
    color: #08204D;
    line-height: 60px;
    background: url('../../../static/img/news/news_bg.png') no-repeat 0 0 / 100%;
  }

  .news-list {
    .cell-content {
      display: flex;
      flex-direction: column;
      padding: 16px 64px;
      cursor: pointer;
      transition: opacity 0.2s ease;

      &:active {
        opacity: 0.72;
      }

      .year {
        font-size: 32px;
        color: #08204D;
        line-height: 44px;
        font-weight: 700;
      }

      .title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-top: 32px;
      }

      .title-text {
        flex: 1;
        font-size: 28px;
        color: #08204D;
        line-height: 40px;
      }

      .title-arrow {
        flex-shrink: 0;
        height: 16px;
        width: auto;
        opacity: 0.72;
        transition: opacity 0.25s ease, transform 0.25s ease;
        animation: arrowNudgeRight 2.2s ease-in-out infinite;
      }

      &:active .title-arrow {
        animation: none;
        opacity: 1;
        transform: translateX(4px);
      }

      .time {
        margin-top: 16px;
        font-size: 24px;
        font-weight: 400;
        color: #97A2B5;
        line-height: 36px;
      }
    }
  }

  @keyframes arrowNudgeRight {
    0%,
    100% {
      transform: translateX(-4px);
      opacity: 0.45;
    }
    50% {
      transform: translateX(6px);
      opacity: 0.85;
    }
  }

  .toTop {
    position: fixed;
    right: 15px;
    bottom: 20%;
    width: 83px;
    height: 83px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/news/index.vue